package org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.tabs.customer_card_tab.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.loyalty_card_detail.LoyaltyCardDetail
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.CustomerCardTypeEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.DiscountNoEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.credit_client.CreditClientModel
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.credit_client.Item
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.jetbrains.compose.web.css.px

@Composable
fun Art(
    selectedLoyaltyCard: LoyaltyCardDetail?,
    creditClient: CreditClientModel?,
    updateLoyaltyCardInfo: (String, dynamic) -> Unit,
    windowSizeMode: WindowSizeModeEnum,
)
{
    val editableType=CustomerCardTypeEnum.LOYALTY_CARDS.value

    Column(
        modifier = Modifier
    )
    {
        MediumContentTitle(
            title = Strings.current().art,
        )

        if (windowSizeMode== WindowSizeModeEnum.Desktop)
        {
            Row(
                modifier = Modifier
            ){
                ArtLeftContent(
                    selectedLoyaltyCard=selectedLoyaltyCard,
                    editableType=editableType,
                    creditClient=creditClient,
                    updateLoyaltyCardInfo = {title:String,value:dynamic->
                        updateLoyaltyCardInfo(title, value)
                    }
                )

                ArtRightContent(
                    selectedLoyaltyCard=selectedLoyaltyCard,
                    updateLoyaltyCardInfo = {title:String,value:dynamic->
                        updateLoyaltyCardInfo(title, value)
                    }
                )
            }
        }else{
            Column {
                ArtLeftContent(
                    selectedLoyaltyCard=selectedLoyaltyCard,
                    editableType=editableType,
                    creditClient=creditClient,
                    updateLoyaltyCardInfo = {title:String,value:dynamic->
                        updateLoyaltyCardInfo(title, value)
                    }
                )

                ArtRightContent(
                    selectedLoyaltyCard=selectedLoyaltyCard,
                    updateLoyaltyCardInfo = {title:String,value:dynamic->
                        updateLoyaltyCardInfo(title, value)
                    }
                )
            }
        }



    }

}

@Composable
private fun ArtLeftContent(
    selectedLoyaltyCard: LoyaltyCardDetail?,
    editableType: Int,
    creditClient: CreditClientModel?,
    updateLoyaltyCardInfo: (String, dynamic) -> Unit,
) {
    Column(
        modifier = Modifier
            .margin(right = Dimen.largePadding)
    )
    {
        DropDownItem(
            modifier = Modifier.margin(
                bottom = Dimen.highLargePadding,
            ) ,
            options = CustomerCardTypeEnum.entries,
            label = Strings.current().cardType,
            selectedItem = CustomerCardTypeEnum.entries.find {
                it.value == selectedLoyaltyCard?.type
            },
            displayText = { item ->
                if (item is CustomerCardTypeEnum) item.title else ""
            },
            onOptionClick = {
               if (it is CustomerCardTypeEnum){
                   updateLoyaltyCardInfo(
                       ApiUtils.Field.type,
                       it.value
                   )
               }
            }
        )

        DropDownItem(
            modifier = Modifier.margin(
                bottom = Dimen.highLargePadding,
            ),
            options = creditClient?.data?.cashAssist?.listCreditClients?.items?: listOf(),
            disable = selectedLoyaltyCard?.type==editableType,
            label = Strings.current().debitCard,
            selectedItem = creditClient?.data?.cashAssist
                ?.listCreditClients?.items?.find {
                    it?.id == selectedLoyaltyCard?.creditClientId
                },
            displayText = { item ->
                if (item is Item) item.name ?: "" else ""
            },
            onOptionClick = {
                if (it is Item) {
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.creditClientId,
                        it.id
                    )
                }
            }
        )

        Row(
            modifier = Modifier
                .margin(
                    bottom = Dimen.highLargePadding,
                )
        )
        {
            CustomEditText(
                modifier = Modifier,
                label = Strings.current().discountWithPercent,
                marginRight = Dimen.semiMediumPadding,
                value =selectedLoyaltyCard?.discount?.freePercent?.toString()?:"",
                width = Dimen.semiNormalEditTextWidth,
                isRequired = false,
                hint = "",
                isDecimal = true,
                marginBottom =0.px,
                onFocusIn = { },
                onFocusOut = {

                    val json= buildJsonObject {
                        put(ApiUtils.Field.freePercent,it.toInt())

                    }
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.discount,
                        json
                    )
                },
                onInputChange = {it, validation ->

                },
            )

            CustomEditText(
                modifier = Modifier,
                label = Strings.current().discountGLWithPercent,
                value =selectedLoyaltyCard?.discount?.masterPercent?.toString()?:"",
                width = Dimen.semiNormalEditTextWidth,
                isRequired = false,
                isDecimal = true,
                hint = "",
                marginBottom =0.px,
                onFocusIn = { },
                onFocusOut = {
                   val json= buildJsonObject {
                       put(ApiUtils.Field.masterPercent,it.toInt())

                   }
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.discount,
                        json
                    )
                },
                onInputChange = {it, validation ->

                },
            )
        }

        DropDownItem(
            modifier = Modifier.margin(
                bottom = Dimen.highLargePadding,
            ),
            options = DiscountNoEnum.entries,
            label = Strings.current().discountNumber,
            selectedItem = DiscountNoEnum.entries.find {
                    it.value == selectedLoyaltyCard?.discount?.numberOfPercent
            }?:DiscountNoEnum.NONE,
            displayText = { item ->
                if (item is DiscountNoEnum) item.title else ""
            },
            onOptionClick = {
                if (it is DiscountNoEnum) {
                    val json= buildJsonObject {
                        put(ApiUtils.Field.numberOfPercent,it.value)
                    }
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.discount,
                        json
                    )
                }
            }
        )


    }
}

@Composable
private fun ArtRightContent(
    selectedLoyaltyCard: LoyaltyCardDetail?,
    updateLoyaltyCardInfo: (String, dynamic) -> Unit,
) {
    Column(
        modifier = Modifier
            .height(Dimen.artHeight)
    )
    {
        Column(
            modifier = Modifier ,
            verticalArrangement = Arrangement.Center,
        )
        {
            CheckboxComponent(
                modifier = Modifier,
                checkStatus = selectedLoyaltyCard?.balanceDiscount?:false,
                title = Strings.current().grantDiscountWhenCharged,
                onChecked = {
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.balanceDiscount,
                        true
                    )
                },
                onUnChecked = {
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.balanceDiscount,
                        false
                    )
                },
            )

            CheckboxComponent(
                modifier = Modifier ,
                checkStatus = selectedLoyaltyCard?.alwaysDiscount?:false,
                title = Strings.current().grantDiscountOnNetItems,
                onChecked = {
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.alwaysDiscount,
                        true
                    )
                },
                onUnChecked = {
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.balancePoints,
                        false
                    )
                },
            )

        }

        Column(
            modifier = Modifier,
            verticalArrangement = Arrangement.Center,
        )
        {
            CheckboxComponent(
                modifier = Modifier ,
                checkStatus = selectedLoyaltyCard?.cashLoad?:false,
                title = Strings.current().cardCanOnlyBeChargedByCash,
                onChecked = {
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.cashLoad,
                        true
                    )
                },
                onUnChecked = {
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.cashLoad,
                        false
                    )
                },
            )

            CheckboxComponent(
                modifier = Modifier
                    .margin(bottom = Dimen.largePadding),
                checkStatus = selectedLoyaltyCard?.balancePoints?:false,
                title = Strings.current().collectPointsWhenCharged,
                onChecked = {
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.balancePoints,
                        true
                    )
                },
                onUnChecked = {
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.balancePoints,
                        false
                    )
                },
            )
        }

        Spacer()

        Row(
            modifier = Modifier
        )
        {
            CustomEditText(
                modifier = Modifier,
                label = Strings.current().rfid,
                isEnabled = false,
                marginRight = Dimen.largePadding,
                marginBottom = 0.px,
                value =selectedLoyaltyCard?.rfid?:"",
                width = Dimen.normalEditTextWidth,
                isRequired = false,
                hint = "",
                onFocusIn = { },
                onFocusOut = {
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.rfid,
                        it
                    )
                },
                onInputChange = {it, validation ->

                },
            )

            CustomEditText(
                modifier = Modifier,
                label = Strings.current().barcode,
                value =selectedLoyaltyCard?.barCode?:"",
                width = Dimen.normalEditTextWidth,
                marginBottom = 0.px,
                isRequired = false,
                hint = "",
                onFocusIn = { },
                onFocusOut = {
                    updateLoyaltyCardInfo(
                        ApiUtils.Field.barCode,
                        it
                    )
                },
                onInputChange = {it, validation ->

                },
            )
        }

    }
}